export default "__VITE_ASSET__1b3cf531__"